import { Modal } from "antd";
import React from "react";
import UserReportForm from "./UserReportForm";

type Props = {
  userReportModalStatus: null | "warning" | "shown";
  setUserReportModalStatus: Function;
  chatId: string;
}

export const UserReportModals = ({ userReportModalStatus, setUserReportModalStatus, chatId }: Props) => {
  const handleConfirmClick = () => {
    setUserReportModalStatus("shown");
  }

  const closeUserReportModal = () => {
    setUserReportModalStatus(null)
  }

  return (
    <React.Fragment>
      <Modal
        visible={userReportModalStatus === "warning"}
        closable
        onOk={handleConfirmClick}
        onCancel={closeUserReportModal}
        title="Prijavi korisnika"
      >
        Prijave s netočnim informacijama neće biti odobrene i podložit će se odgovarajućim sankcijama. Želite li nastaviti s prijavom?
      </Modal>

      <UserReportForm
        visible={userReportModalStatus === "shown"}
        onCancel={closeUserReportModal}
        chatId={chatId}
      />
    </React.Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SingleChat/UserReportModals.tsx